"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _material = require("@mui/material");
var _Text = _interopRequireDefault(require("../../components/Text"));
var _theme = require("../../theme");
var _TextInput = _interopRequireDefault(require("../../components/TextFields/TextInput"));
var _DateInput = _interopRequireDefault(require("../../components/TextFields/DateInput"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormGroup = _interopRequireDefault(require("@mui/material/FormGroup"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var Services = _interopRequireWildcard(require("../../services"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable consistent-return */
var styles = {
  benefitBlock: {
    backgroundColor: _theme.colors.surface,
    display: 'block',
    padding: 15,
    position: 'relative',
    border: "1px solid #eee",
    borderRadius: 3,
    marginBottom: 10,
    marginTop: 10
  },
  signageAcceptBox: {
    paddingTop: '10px',
    marginTop: '-15px'
  },
  signature: {
    fontFamily: 'this.props.product.dependentCoverageSetting',
    fontWeight: 'bold'
  }
};

/**
 * @param changes
 * @returns {JSX.Element}
 */
var formatChanges = function formatChanges(changes) {
  var lines = changes.split('\n');
  return /*#__PURE__*/_react["default"].createElement("div", null, lines.map(function (line) {
    line = line.trim();
    if (line.length === 0) {
      return null;
    }
    if (line.charAt(0) === '-') {
      line = line.slice(1);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      color: _theme.colors.darkGrey,
      medium: true,
      display: "block",
      customStyle: {
        paddingLeft: 5
      }
    }, "\u2022"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      color: _theme.colors.darkGrey,
      medium: true,
      display: "block",
      customStyle: {
        paddingLeft: 5
      }
    }, line));
  }));
};

/**
 * @param classes
 * @param whitelabel
 * @param title
 * @param benefitData
 * @returns {JSX.Element}
 */
var benefitBlock = function benefitBlock(whitelabel, title, benefitData) {
  if (benefitData.changes.length === 0) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.benefitBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: whitelabel.primaryColor || _theme.colors.skyBlue,
    mediumLarge: true,
    bold: true
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: 20
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true,
    bold: true,
    display: "block",
    margin: "0 0 5px 0"
  }, _i18n["default"].t(_tokens["default"].labels.amendments.requestedChanges)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true,
    display: "block"
  }, formatChanges(benefitData.changes))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: 20
    }
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.amendments.soloRateCurrent)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true,
    margin: "5px 0 0 0"
  }, "$", benefitData.rates.current.solo)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.amendments.duoRateCurrent)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true,
    margin: "5px 0 0 0"
  }, "$", benefitData.rates.current.duo)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.amendments.familyRateCurrent)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true,
    margin: "5px 0 0 0"
  }, "$", benefitData.rates.current.family))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 2,
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.amendments.soloRateNew)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: whitelabel.primaryColor || _theme.colors.skyBlue,
    medium: true,
    bold: true,
    margin: "5px 0 0 0"
  }, "$", benefitData.rates["new"].solo)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.amendments.duoRateNew)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: whitelabel.primaryColor || _theme.colors.skyBlue,
    medium: true,
    bold: true,
    margin: "5px 0 0 0"
  }, "$", benefitData.rates["new"].duo)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true,
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.amendments.familyRateNew)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: whitelabel.primaryColor || _theme.colors.skyBlue,
    medium: true,
    bold: true,
    margin: "5px 0 0 0"
  }, "$", benefitData.rates["new"].family)))));
};

/**
 * @param classes
 * @param classData
 * @param whitelabel
 * @param amendment
 * @param isAuthorityView
 * @param completeApproval
 * @returns {JSX.Element}
 * @constructor
 */
var AmendmentDisplay = function AmendmentDisplay(_ref) {
  var classData = _ref.classData,
    whitelabel = _ref.whitelabel,
    amendment = _ref.amendment,
    isAuthorityView = _ref.isAuthorityView,
    completeApproval = _ref.completeApproval;
  var _useState = (0, _react.useState)(amendment.signage.signature || ""),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    authoritySignature = _useState2[0],
    setAuthoritySignature = _useState2[1];
  var _useState3 = (0, _react.useState)(amendment.signage.name || ""),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    authorityName = _useState4[0],
    setAuthorityName = _useState4[1];
  var _useState5 = (0, _react.useState)(amendment.signage.acceptedTerms || false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    authorityAcceptedTerms = _useState6[0],
    setAuthorityAcceptedTerms = _useState6[1];
  var _useState7 = (0, _react.useState)(amendment.signage.timestampOfAcceptance || null),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    authorityTimestampOfAcceptance = _useState8[0],
    setAuthorityTimestampOfAcceptance = _useState8[1];
  var _useState9 = (0, _react.useState)(amendment.signage.datedOn ? Services.dates.formatIncomingDate(amendment.signage.datedOn) : null),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    authorityDatedOn = _useState10[0],
    setAuthorityDatedOn = _useState10[1];
  var _useState11 = (0, _react.useState)({}),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    errors = _useState12[0],
    setErrors = _useState12[1];

  /**
   * Validate the signage block and call the completeApproval
   * @returns {Promise<null>}
   * @private
   */
  var _completeApproval = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var authoritySignatureError, authorityNameError, authorityAcceptedTermsError, authorityDatedOnError;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Services.validateInput('checkEmpty', authoritySignature);
          case 2:
            authoritySignatureError = _context.sent;
            _context.next = 5;
            return Services.validateInput('checkEmpty', authorityName);
          case 5:
            authorityNameError = _context.sent;
            authorityAcceptedTermsError = !authorityAcceptedTerms ? _i18n["default"].t(_tokens["default"].labels.banking.youMustAcceptTermsError) : false;
            _context.next = 9;
            return Services.validateInput('date', authorityDatedOn);
          case 9:
            authorityDatedOnError = _context.sent;
            if (authoritySignature !== authorityName) {
              authoritySignatureError = _i18n["default"].t(_tokens["default"].labels.signage.signageNameError);
            }
            setErrors({
              authoritySignatureError: authoritySignatureError,
              authorityNameError: authorityNameError,
              authorityAcceptedTermsError: authorityAcceptedTermsError,
              authorityDatedOnError: authorityDatedOnError
            });
            if (!(authoritySignatureError || authorityNameError || authorityAcceptedTermsError || authorityDatedOnError)) {
              _context.next = 14;
              break;
            }
            return _context.abrupt("return", null);
          case 14:
            completeApproval({
              name: authorityName,
              signature: authoritySignature,
              acceptedTerms: authorityAcceptedTerms,
              timestampOfAcceptance: authorityTimestampOfAcceptance,
              datedOn: dates.getUTC(authorityDatedOn)
            });
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function _completeApproval() {
      return _ref2.apply(this, arguments);
    };
  }();
  var amendmentStatus = amendment.status.toUpperCase();
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: 30
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "0 0 5px 0"
  }, _i18n["default"].t(_tokens["default"].labels.admin.effectiveDate)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true
  }, dates.getUTC(amendment.effectiveDate, 'll', _i18n["default"].locale)), amendment.requestedAccountDetailChanges.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "30px 0 5px 0"
  }, _i18n["default"].t(_tokens["default"].labels.amendments.accountDetailChanges)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true
  }, formatChanges(amendment.requestedAccountDetailChanges))), amendment.requestedClassChanges.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "30px 0 5px 0"
  }, _i18n["default"].t(_tokens["default"].labels.amendments.classChanges)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true
  }, formatChanges(amendment.requestedClassChanges))), amendment.requestedDivisionChanges && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "30px 0 5px 0"
  }, _i18n["default"].t(_tokens["default"].labels.amendments.divisionChanges)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true
  }, formatChanges(amendment.requestedDivisionChanges))), amendment.requestedAdminFeeChanges && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "30px 0 5px 0"
  }, _i18n["default"].t(_tokens["default"].labels.amendments.adminFeeChanges)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true
  }, formatChanges(amendment.requestedAdminFeeChanges))), amendment.requestedBenefitChanges.selectedClasses.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "30px 0 5px 0"
  }, _i18n["default"].t(_tokens["default"].labels.amendments.benefitChanges)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    medium: true
  }, _i18n["default"].t(_tokens["default"].labels.amendments.followingClassesWillBeAmended)), amendment.requestedBenefitChanges.selectedClasses.map(function (selectedClassID) {
    return /*#__PURE__*/_react["default"].createElement(_material.Chip, {
      size: "medium",
      label: classData[selectedClassID].title,
      color: "default",
      clickable: false,
      variant: "default",
      style: {
        cursor: "default",
        padding: 15,
        margin: "10px 10px 10px 0",
        borderRadius: 20,
        borderWidth: 2,
        fontFamily: _theme.fonts.type.heading,
        fontSize: 12,
        color: '#000',
        minWidth: 100,
        backgroundColor: '#eee'
      }
    });
  }), benefitBlock(whitelabel, _i18n["default"].t(_tokens["default"].titles.lifeInsurance), amendment.requestedBenefitChanges.lifeInsurance), benefitBlock(whitelabel, _i18n["default"].t(_tokens["default"].titles["ad&d"]), amendment.requestedBenefitChanges.add), benefitBlock(whitelabel, _i18n["default"].t(_tokens["default"].titles.dependentLife), amendment.requestedBenefitChanges.dependentLife), benefitBlock(whitelabel, _i18n["default"].t(_tokens["default"].titles.shortTermDisability), amendment.requestedBenefitChanges.std), benefitBlock(whitelabel, _i18n["default"].t(_tokens["default"].titles.longTermDisability), amendment.requestedBenefitChanges.ltd), benefitBlock(whitelabel, _i18n["default"].t(_tokens["default"].titles.criticalIllness), amendment.requestedBenefitChanges.criticalIllness), benefitBlock(whitelabel, _i18n["default"].t(_tokens["default"].titles.drugs), amendment.requestedBenefitChanges.drugs), benefitBlock(whitelabel, _i18n["default"].t(_tokens["default"].titles.healthcare), amendment.requestedBenefitChanges.healthcare), benefitBlock(whitelabel, _i18n["default"].t(_tokens["default"].titles.dental), amendment.requestedBenefitChanges.dental), benefitBlock(whitelabel, _i18n["default"].t(_tokens["default"].titles.spendingAccounts), amendment.requestedBenefitChanges.spendingAccounts), benefitBlock(whitelabel, _i18n["default"].t(_tokens["default"].titles.efap), amendment.requestedBenefitChanges.efap), benefitBlock(whitelabel, _i18n["default"].t(_tokens["default"].titles.virtualHealthCare), amendment.requestedBenefitChanges.virtualHealthcare)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: _theme.colors.darkGrey,
    mediumLarge: true,
    bold: true,
    margin: "30px 0 0 0"
  }, _i18n["default"].t(_tokens["default"].labels.amendments.signingAuthoritySignature)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: _i18n["default"].t(_tokens["default"].labels.masterApplication.authoritySignature),
    fullWidth: true,
    variant: "outlined",
    value: authoritySignature,
    onChange: function onChange(e) {
      return setAuthoritySignature(e.target.value);
    },
    inputProps: {
      inputProps: {
        style: _objectSpread({}, styles.signature)
      }
    },
    disabled: !isAuthorityView || amendmentStatus === 'APPROVED',
    error: errors.authoritySignatureError
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: _i18n["default"].t(_tokens["default"].labels.masterApplication.authorityName),
    fullWidth: true,
    variant: "outlined",
    value: authorityName,
    onChange: function onChange(e) {
      return setAuthorityName(e.target.value);
    },
    disabled: !isAuthorityView || amendmentStatus === 'APPROVED',
    error: errors.authorityNameError
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
    label: _i18n["default"].t(_tokens["default"].labels.masterApplication.authorityDatedOn),
    fullWidth: true,
    variant: "outlined",
    value: authorityDatedOn,
    onChange: function onChange(e) {
      return setAuthorityDatedOn(e.target.value);
    },
    disabled: !isAuthorityView || amendmentStatus === 'APPROVED',
    error: errors.authorityDatedOnError
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    style: styles.signageAcceptBox
  }, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
    row: true
  }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
    control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      checked: Boolean(authorityAcceptedTerms),
      onChange: function onChange() {
        setAuthorityAcceptedTerms(!authorityAcceptedTerms);
        setAuthorityTimestampOfAcceptance(dates.getUTC());
      },
      value: "authorityAcceptedTerms",
      disabled: !isAuthorityView || amendmentStatus === 'APPROVED'
    }),
    label: _i18n["default"].t(_tokens["default"].labels.amendments.amendmentAcknowledgement)
  })), errors.authorityAcceptedTermsError && /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
    error: true
  }, _i18n["default"].t(_tokens["default"].labels.banking.youMustAcceptTermsError))))), isAuthorityView && amendmentStatus === 'UNDER REVIEW' && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    customStyle: {
      display: 'block',
      height: 50,
      textTransform: "capitalize",
      fontSize: 16,
      margin: "40px 0 0 0",
      marginLeft: 'auto'
    },
    onClick: _completeApproval
  }, _i18n["default"].t(_tokens["default"].buttons.approveAmendment)));
};
var _default = exports["default"] = AmendmentDisplay;